export const SIZE = [
  'large',
  'medium',
  'small',
]
